import Vue from 'vue'

export const PromessaEventBus = new Vue()



// WEBPACK FOOTER //
// ./src/components/events/promessaEventBus.js